import { menuselect } from "@/constant/menuselect";
import router from "@/router";

let str = "会计核算";
export const config = {
  title: "财务管理",
  headerInfo:
    "聚焦于提高医院的财务管理效率、优化资源配置、支持决策制定以及确保财务信息的准确性和安全性。",
  headerImg: require("@/assets/images/finance/Rectangle 19header.png"),
  activeTitle: str,
  activeSubTitle: str,

  navList: [
    {
      name: "财务管理",
      children: menuselect(),
    },
    {
      name: "会计核算",
      desc: "基于《政府会计制度》及医院管理内控要求，形成“事前预算、过程核算、事后结算”的一体化财务解决方案，从业财一体化、全成本核算视角给医院管理层决策提供真实可靠的管理数据和决策依据。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Frame 1060one.png"),
        },
        {
          title: "产品特点",
          desc: "双轨制会计核算模式，完全满足政府会计要求在一个账簿下财务会计和预算会计的适度分离又相互衔接的核算模式，可对会计科目进行经济类科目，功能类分类。支持集团化、多院区的财务核算模式。",
          img: require("@/assets/images/finance/Frame 1061one.png"),
        },
      ],
    },
    {
      name: "收入管理",
      desc: "衔接HIS营收数据，实现系统自动稽核与财务核算。完善营收稽核体系，通过系统实现营收四级稽核流程。保障医院营收资金安全，营收数据可追溯，可分析。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Frame 1062two.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: "打通线上数据追溯链，收入结算明细一键追溯多维分析。收入数据支持各种形式和维度自由组合的直观的BI展示，助力运营决策分析。",
          img: require("@/assets/images/finance/Frame 1063two.png"),
        },
      ],
    },
    {
      name: "支出管理",
      desc: "帮助医院实现无纸化自动化的应付流程管理，例如，线上确认收货可自动完成三单匹配、电子发票验证管理；付款申请线上审批，网银直连一键支付；付款后电子银行回单可自动导入对账。同时通过业务流和财务流的打通加强了医院应付内控管理，提高财务数据的准确性。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Frame 1063three.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: "构建统一的应付管理平台，支持对付款账期的管理，根据账期自动生成付款计划，财务可结合资金管理合理调整资源，同时支持不同维度的财务分析。",
          img: require("@/assets/images/finance/Frame 1064three.png"),
        },
      ],
    },
    {
      name: "资金监管",
      desc: "伴随各类线上流程医疗服务的开展，全国范围内的患者都已经广泛地开始使用移动端的支付平台，如支付宝、微信、自助机等。多样化的支付方式，为患者提供了更便捷的医疗服务，也为传统的医院HIS系统以及财务管理模式带来巨大压力，传统财务对账方式在新型支付模式的冲击下，隐患日渐突出。敬在信息资金安全监管平台，整合了各类支付方式，聚合全院支付场景，进行统一支付、统一对账、统一管理，并根据国务院下发指导意见进行统筹规划，构筑账户管理、结算管理、票据管理以及资金监管四大版块，切实为医院构建信息化资金安全屏障。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Group 1073four.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: "以为患者提供统一支付方式为核心，提升医院管理水平为目标，整合多渠道多场景支付，整合多渠道多场景支付交易数据，自动抽取，自动对账，结合电子发票，形成管理闭环。",
          img: require("@/assets/images/finance/Frame 1066four.png"),
        },
      ],
    },
    {
      name: "电子发票管理",
      desc: "电子发票是信息时代票据形态及服务管理方式变革的新产物，是储存于信息系统内的电子凭证，电子发票通过简化发票的流转、贮存、查验、对比、降低纳税成本、强化发票管理。电子发票可直接对接HRP系统，减少数据孤岛，简化流程，提高运营效率实现发票线上线下协同管理，通过票据池所管理的发票，自助验证识别，降低人为错误风险。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Group 1075five.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: "",
          img: require("@/assets/images/finance/Group 1077five.png"),
        },
      ],
    },
    {
      name: "自动对账与银医直联",
      desc: "为更好的提供患者服务，降低医院收费人员工作量，医院收费窗口呈现多样化设置，除了传统的银联支付、现金支付、POS机刷卡等在医院广泛应用外，微信支付、支付宝支付等新的支付方式也在院方普及。多样支付大大方便了患者，却对后台财务人员提出巨大考验，在此背景下，敬在信息-自动对账系统应运而生。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Frame 1069six.png"),
        },
        {
          title: "系统特点及应用价值",
          desc: "",
          img: require("@/assets/images/finance/Frame 1070six.png"),
        },
      ],
    },
    {
      name: "电子会计档案",
      desc: "电子档案管理系统是一个采用档案电子化、影像数字化、办公无纸化以及信息网络化等先进技术，实现包括档案文件、声音、影像、文本在内的多媒体档案资源的存储和查询检索的计算机系统，为档案资料管理、利用和保护提供了有效的技术保证，可大大节约数据存储空间，无限地延长档案材料保存时间，同时为查阅、利用档案文献带来了极大的便利。",
      tabList: [{}],
      [str]: [
        {
          title: "",
          desc: " ",
          img: require("@/assets/images/finance/Group 1080seven.png"),
        },
        {
          title: "应用价值",
          desc: "",
          img: require("@/assets/images/finance/Frame 1071seven.png"),
        },
      ],
    },
    
  ],
};
